import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-semibold" }, "Constraint: ", -1)
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  class: "mt-2 pl-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_display = _resolveComponent("property-display")!
  const _component_validation_result_display = _resolveComponent("validation-result-display", true)!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (_ctx.result.resultPath)
      ? (_openBlock(), _createBlock(_component_property_display, {
          key: 0,
          term: _ctx.result.resultPath.id,
          class: "has-text-weight-semibold"
        }, null, 8, ["term"]))
      : (_ctx.result.sourceConstraintComponent)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_property_display, {
              term: _ctx.result.sourceConstraintComponent.id
            }, null, 8, ["term"])
          ]))
        : _createCommentVNode("", true),
    (_ctx.result.resultMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.result.resultMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.result.detail && _ctx.result.detail.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.detail, (detail, detailIndex) => {
            return (_openBlock(), _createBlock(_component_validation_result_display, {
              key: detailIndex,
              result: detail
            }, null, 8, ["result"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}